<template>
    <b-card no-body>
        <b-card-header>
            <i class="fa fa-align-justify mr-2" />
            <span>Dashboard</span>
        </b-card-header>
        <div class="p-3">
            <c-loader v-if="isLoading" :loader="isLoading" />
            <div v-if="!isLoading && hasDashboards">
                <div class="mb-2">
                    <b-form-group :label="$t('dashboard.selectCard')">
                        <b-form-select v-model="selected" :options="options" />
                    </b-form-group>
                </div>
                <b-card v-if="selected" no-body>
                    <dashboard :url="selected" />
                </b-card>
            </div>
            <div v-if="!isLoading && !hasDashboards">
                <h4>Quer ter acesso a relatórios customizados como os exemplos abaixo?</h4>
                <h6>
                    Basta solicitar um orçamento ao nosso time pelo email
                    <a href="mailto:contato@coblue.com.br">contato@coblue.com.br</a>
                </h6>

                <b-row>
                    <b-col sm="12" md="12" lg="6">
                        <img class="w-100" src="@/assets/images/dashboard/bar-line-chart.svg" />
                    </b-col>
                    <b-col sm="12" md="12" lg="6">
                        <img class="w-100" src="@/assets/images/dashboard/bar-chart.svg" />
                    </b-col>
                </b-row>
                <b-row class="my-3">
                    <b-col sm="6" md="6" lg="3">
                        <img src="@/assets/images/dashboard/single-bar-chart.svg" class="w-100" />
                    </b-col>
                    <b-col sm="6" md="6" lg="3">
                        <img src="@/assets/images/dashboard/pizza-chart.svg" class="w-100" />
                    </b-col>
                    <b-col sm="12" md="12" lg="6">
                        <img src="@/assets/images/dashboard/line-chart.svg" class="w-100" />
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-card>
</template>
<script>
import CLoader from '@/views/components/loader'
import Dashboard from './components/Dashboard'
import { getDashboards } from './api'
export default {
    components: {
        CLoader,
        Dashboard,
    },
    data() {
        return {
            options: [],
            dashboards: [],
            selected: null,
            isLoading: true,
        }
    },
    mounted() {
        this.getDashboards()
    },
    methods: {
        getDashboards() {
            getDashboards()
                .then((dashboards) => {
                    this.dashboards = dashboards
                    this.options = dashboards.map((dashboard) => {
                        const { title, url } = dashboard
                        return {
                            value: url,
                            text: title,
                        }
                    })
                    if (dashboards.length) {
                        this.selected = dashboards[0].url
                    }
                })
                .finally(() => (this.isLoading = false))
        },
    },
    computed: {
        hasDashboards() {
            return Array.isArray(this.dashboards) && this.dashboards.length > 0
        },
    },
}
</script>
